import { FC } from 'react';
import {
  EDuplicateMatchedField,
  TMatchCriteria,
} from 'data/types/duplicateManagement.types';

// Per-rule rendering — closes GROW-4015. The BE returns snake_case keys
// inside the parsed match_criteria object.

const MATCHED_FIELD_LABEL: Record<EDuplicateMatchedField, string> = {
  [EDuplicateMatchedField.LAST_NAME]: 'Last name',
  [EDuplicateMatchedField.EMAIL]: 'Email',
  [EDuplicateMatchedField.PHONE]: 'Phone',
};

type Props = {
  matchCriteria: TMatchCriteria | null;
};

const containerStyle: React.CSSProperties = {
  padding: '8px 12px',
  marginBottom: 12,
  background: '#f3f4f6',
  borderRadius: 6,
  fontSize: 13,
  color: '#374151',
};

const labelStyle: React.CSSProperties = {
  fontWeight: 600,
  marginRight: 6,
};

const MatchCriteriaSummary: FC<Props> = ({ matchCriteria }) => {
  if (!matchCriteria) {
    return (
      <div style={containerStyle}>
        <span style={labelStyle}>Match details:</span>
        unavailable (legacy detection rule)
      </div>
    );
  }

  if (matchCriteria.rule === 'two_of_three') {
    const labels = matchCriteria.matched_fields.map(
      f => MATCHED_FIELD_LABEL[f] ?? f,
    );
    return (
      <div style={containerStyle}>
        <span style={labelStyle}>Matched on:</span>
        {labels.join(' · ')}
      </div>
    );
  }

  if (matchCriteria.rule === 'normalized_address_exact') {
    return (
      <div style={containerStyle}>
        <span style={labelStyle}>Matched on:</span>
        normalized address
        {matchCriteria.normalized_address
          ? ` (${matchCriteria.normalized_address})`
          : ''}
      </div>
    );
  }

  if (matchCriteria.rule === 'fuzzy_name_zip_city') {
    const pct = Math.round((matchCriteria.name_similarity ?? 0) * 100);
    return (
      <div style={containerStyle}>
        <span style={labelStyle}>Matched on:</span>
        {pct}% name similarity · {matchCriteria.city} · {matchCriteria.zip_code}
      </div>
    );
  }

  // Forward-compat: BE may introduce new rule shapes. Don't crash.
  return (
    <div style={containerStyle}>
      <span style={labelStyle}>Match details:</span>
      details unavailable for this rule
    </div>
  );
};

export default MatchCriteriaSummary;
